import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CoachGrantAccess from 'components/signUp/CoachGrantAccess';

function mapStateToProps(state) {
  return {
    athleteAccessResponse: state.signupReducer.get('athleteAccessResponse')
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: {
      signUpActions: bindActionCreators(require('actions/signUpActions'), dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CoachGrantAccess);


// WEBPACK FOOTER //
// ./src/containers/CoachGrantAccessContainer.js